import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from '../hocs';
import { Spinner } from '../components';
import { pickupsSignIn, pickupsSignOut, setPickupsLoading } from '../store/actions';
import { apiGetPickupsUser } from '../api';
import ErrorScene from '../scenes/ErrorScene/ErrorScene';
import { isJWTExpired, jwtDecode } from '../helpers';
import { setPickupsUser } from '../store/actions';

const PrivatRouteWithTokenLogin = (props) => {
  const {
    component: Component,
    errorComponent: ErrorComponent,
    render,
    match,
    history,
    componentProps,
    ...rest
  } = props;

  const { token } = match.params;
  const [initialLoading, setInitialLoading] = useState(!!token);
  const [tokenApproved, setTokenApproved] = useState(false);
  const dispatch = useDispatch();
  const onLogIn = (data, onReady) => dispatch(pickupsSignIn(data, onReady));
  const onSignOut = () => dispatch(pickupsSignOut());
  const onLoading = (isLoading) => dispatch(setPickupsLoading(isLoading));
  const onSetPickupUser = (pickupUserData) => dispatch(setPickupsUser(pickupUserData));

  const { authenticated, pickupUserToken, loading } = useSelector((state) => {
    return {
      authenticated: !!state.pickupsApp.pickupToken,
      pickupUserToken: state.pickupsApp.pickupToken,
      loading: state.pickupsApp.loading,
    };
  });

  useEffect(
    () => {
      if (isJWTExpired(pickupUserToken)) {
        onSignOut();
        setTokenApproved(false);
      }

      if (!!token) {
        const tokenData = jwtDecode(token);
        const savedTokenData = jwtDecode(pickupUserToken);
        const pickupUserId = tokenData?.uid;

        if (pickupUserId !== savedTokenData?.uid) {
          onSignOut();
        }

        apiGetPickupsUser(
          token,
          pickupUserId,
          (response) => {
            setInitialLoading(false);
            setTokenApproved(true);
            onLogIn({
              token: token,
            });

            onSetPickupUser(response);
          },
          () => {
            onSignOut();
            onLoading(false);
            setInitialLoading(false);
            setTokenApproved(false);
          }
        );
      } else {
        setInitialLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [token]
  );

  const getContent = () => {
    if (initialLoading) {
      return null;
    } else if (!!authenticated) {
      return (
        <>
          <Component {...rest} {...componentProps} />
        </>
      );
    } else if (tokenApproved) {
      return (
        <>
          <Component {...rest} {...componentProps} />
        </>
      );
    } else {
      return <ErrorScene />;
    }
  };

  return (
    <>
      {loading && <Spinner />}
      {getContent()}
    </>
  );
};

export default withRouter(PrivatRouteWithTokenLogin);
